module.exports = __webpack_public_path__ + "img/siwa.54f91d12.png";